import { Dialog, DialogTitle, DialogContent, Radio, Button } from '@mui/material';
import React, { useState, useMemo } from 'react';
import { useMyContext } from '../../../context/MyContext';
import { RiMoneyRupeeCircleFill } from "react-icons/ri";
import { useNavigate } from 'react-router-dom';
import { IoIosCloseCircle } from "react-icons/io";
import { FaCheckCircle } from "react-icons/fa";
import { HiOutlineTruck } from "react-icons/hi2";
import Spinner from '../../../component/spinner/spinner';
import axios from 'axios';
import { toast } from 'react-toastify';
import '../../css/custom-scrollbar.css';
import { Base_Url, reverseShipment, createShippment } from '../../../config/config';
const ViewRateForword = ({ isopen, onClose, data, type }) => {
  const { isDarkMode } = useMyContext();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const userData = JSON.parse(localStorage.getItem('user')) || {};

  const handleNavigation = () => {
    navigate('/shipments/all');
  };

  // Dynamic table data generation with support for future partner additions
  const tableData = useMemo(() => {
    if (!data?.data?.partners_pricing) return [];

    // Collect all partners dynamically
    const allPartners = Object.keys(data.data.partners_pricing);

    // Flatten and transform pricing data for all partners
    return allPartners.flatMap(partner =>
      Object.entries(data.data.partners_pricing[partner] || {}).map(([mode, pricing], index) => ({
        id: `${partner}-${mode}-${index}`,
        courier: partner.toLowerCase(),
        mode,
        zone: data.data.zone,
        basePrice: pricing.total_price,
        codExtra: pricing.cod_extra,
        // Handling cases where cod_total_price might be 0
        codTotalPrice: pricing.cod_total_price !== 0
          ? pricing.cod_total_price
          : pricing.total_price,
        shippingMode: mode,
        // Spread any additional partner-specific data
        ...pricing
      }))
    );
  }, [data]);

  const handleRadioChange = (event, row) => {
    setSelectedRowId(row.id);
    setSelectedRowData(row);
  };

  const handleCreateShipment = async () => {
    const token = localStorage.getItem('token');
    const cusid = localStorage.getItem('cus_id');

    if (selectedRowData) {
      let requestBody;

      // Check if it's a bulk order
      if (data.bulk_order === true) {
        // For bulk orders, use array format with selected_orders
        requestBody = {
          order_id: data.selected_orders, // This should be an array like ['262819868300', '507837899536']
          shipping_mode: selectedRowData.shippingMode,
          partner: selectedRowData.courier
        };
      } else {
        // For single orders, use the original format
        requestBody = {
          order_id: data.order_id,
          partner: selectedRowData.courier,
          shipping_mode: selectedRowData.shippingMode
        };
      }

      setIsSubmitting(true);
      try {
        const response = await axios.post(Base_Url + createShippment, requestBody, {
          headers: {
            token,
            cus_id: cusid,
            'Content-Type': 'application/json',
          },
        });

        if (response.data.status === "SUCCESS") {
          const { summary, success_orders, failed_orders } = response.data;

          if (summary.failed === 0) {
            // All successful
            toast.success(`🎉 ${summary.success} shipment${summary.success > 1 ? 's' : ''} created successfully!`);
            handleClose();
            handleNavigation();
          } else if (summary.success === 0) {
            // All failed
            const errorMessages = failed_orders.map(order =>
              `❌ Order ${order.order_id}: ${order.message || "Unknown error"}`
            ).join('\n');
            toast.error(`Failed to create ${summary.failed} shipment${summary.failed > 1 ? 's' : ''}.\n${errorMessages}`);
          } else {
            // Mixed success/failure
            toast.info(`📊 ${summary.success} successful, ${summary.failed} failed out of ${summary.total} total shipments`);
            // failed_orders.forEach(order => {
            //   toast.error(`❌ Order ${order.order_id}: ${order.message || "Unknown error"}`);
            // });
            // toast.error(failed_orders.message);
            failed_orders.forEach(order => {
              const remarks =
                order?.response?.packages?.[0]?.remarks?.join(', ') ||
                order.message ||
                "Unknown error";

              toast.error(`❌ Order ${order.order_id}: ${remarks}`);
            });
          }
        } else {
          // General error case
          const errorMessage = Array.isArray(response.data.message)
            ? response.data.message.join(', ')
            : response.data.message || "An error occurred";
          toast.error(errorMessage);
        }

      } catch (error) {
        console.error("API Error:", error);
        toast.error(error.response?.data?.message || "An error occurred");
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const handleClose = () => {
    onClose();
  };

  const tableHeaders = useMemo(() => {
    const baseHeaders = [
      'Select',
      'Courier',
      'Mode',
      'Zone',
      'Forward Price',
      'COD Price',
      'Total Price'
    ];

    return baseHeaders;
  }, [tableData]);

  // Renders the courier logo/badge — same partner logic as before, just reused for cards
  const renderCourierLogo = (courier) => {
    const c = courier?.toLowerCase();
    if (c === "delhivery") {
      return (
        <img
          src={isDarkMode ? "/assets/images/DELHIVERYWhite.png" : "/assets/images/Delhivery.png"}
          alt="Delhivery"
          className="h-4 w-auto object-contain"
        />
      );
    }
    if (c === "ecom") {
      return (
        <img
          src={isDarkMode ? "/assets/images/logoecom.svg" : "/assets/images/ecom-express-logo.png"}
          alt="Ecom Express"
          className={`object-contain w-auto ${isDarkMode ? "h-4" : "h-7"}`}
        />
      );
    }
    if (c === "ekart") {
      return <img src="/assets/images/ekart.png" alt="Ekart" className="h-6 w-auto object-contain" />;
    }
    if (c === "xpressbees") {
      return <img src="/assets/images/xpressbess.png" alt="XpressBees" className="h-4 w-auto object-contain" />;
    }
    if (c === "bluedart") {
      return <img src="/assets/images/bluedart.png" alt="bluedart" className="h-4 w-auto object-contain" />;
    }
    return (
      <span className="inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-semibold bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200">
        {courier}
      </span>
    );
  };

  return (
    <Dialog
      open={isopen}
      onClose={onClose}
      maxWidth="md"
      className={`custom-scrollbar ${isDarkMode ? "dark:bg-darkmodeColor text-white" : ""}`}
      sx={{
        '& .MuiDialog-paper': {
          width: '90%',
          maxWidth: '900px',
          height: '75vh',
          borderRadius: "28px",
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }
      }}
    >
      {/* Gradient header */}
      <div className="relative bg-gradient-to-r from-indigo-600 via-purple-600 to-violet-700 px-6 py-3 shadow-lg flex-shrink-0">
        <div className="flex items-center gap-1.5">
          <div className="w-10 h-10 rounded-xl bg-white/15 backdrop-blur-sm flex items-center justify-center flex-shrink-0">
            <RiMoneyRupeeCircleFill className="text-white" size={20} />
          </div>
          <div>
            <p className="text-[11px] uppercase tracking-widest text-white/70 font-semibold">Compare & Choose</p>
            <h2 className="text-base md:text-lg font-bold text-white">Rate Calculator</h2>
          </div>
        </div>
        <button
          type="button"
          onClick={handleClose}
          className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center rounded-full bg-white/15 hover:bg-white/25 backdrop-blur-sm transition-all hover:scale-105"
        >
          <IoIosCloseCircle size={20} className="text-white" />
        </button>
      </div>

      <DialogContent
        className={`custom-scrollbar flex-1 px-4 md:px-6 py-5 ${isDarkMode ? "dark:bg-darkmodeColor text-white" : "bg-gray-50"}`}
        sx={{ overflowY: 'auto' }}
      >
        {tableData.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
            {tableData.map((row) => {
              const isSelected = selectedRowId === row.id;
              return (
                <div
                  key={row.id}
                  onClick={(e) => handleRadioChange(e, row)}
                  className={`relative cursor-pointer rounded-2xl p-4 border-2 transition-all duration-200 group
                    ${isSelected
                      ? "border-indigo-500 bg-gradient-to-br from-indigo-50 to-purple-50 dark:from-indigo-900/30 dark:to-purple-900/20 shadow-lg shadow-indigo-500/15 -translate-y-0.5"
                      : `${isDarkMode ? "border-gray-800 bg-gray-900/60" : "border-gray-100 bg-white"} hover:border-indigo-300 hover:shadow-md hover:-translate-y-0.5`
                    }`}
                >
                  {/* selected check badge */}
                  {isSelected && (
                    <div className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-indigo-600 flex items-center justify-center shadow-md">
                      <FaCheckCircle className="text-white" size={12} />
                    </div>
                  )}

                  {/* Header: logo + radio */}
                  <div className="flex items-center justify-between mb-3">
                    <div className="h-7 flex items-center">
                      {renderCourierLogo(row.courier)}
                    </div>
                    <Radio
                      checked={isSelected}
                      onChange={(event) => handleRadioChange(event, row)}
                      value={row.id}
                      name="selectRow"
                      inputProps={{ 'aria-label': 'select row' }}
                      size="small"
                      onClick={(e) => e.stopPropagation()}
                      sx={{
                        color: isDarkMode ? '#6366f1' : '#818cf8',
                        '&.Mui-checked': { color: '#6366f1' },
                      }}
                    />
                  </div>

                  {/* Mode + Zone badges */}
                  <div className="flex items-center gap-2 mb-3">
                    <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] font-semibold bg-indigo-100 text-indigo-700 dark:bg-indigo-900/40 dark:text-indigo-300">
                      <HiOutlineTruck size={11} /> {row.mode || "N/A"}
                    </span>
                    <span className="inline-flex items-center px-2.5 py-1 rounded-full text-[10px] font-semibold bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300">
                      Zone {row.zone || "N/A"}
                    </span>
                  </div>

                  {/* Price breakdown */}
                  <div className={`rounded-xl p-3 space-y-1.5 ${isDarkMode ? "bg-gray-800/50" : "bg-gray-50"}`}>
                    <div className="flex items-center justify-between text-xs">
                      <span className="text-gray-400">Forward Price</span>
                      <span className="font-medium text-gray-700 dark:text-gray-200">{row.basePrice ? `₹${row.basePrice}` : "N/A"}</span>
                    </div>
                    <div className="flex items-center justify-between text-xs">
                      <span className="text-gray-400">COD Extra</span>
                      <span className="font-medium text-gray-700 dark:text-gray-200">{row.codExtra ? `₹${row.codExtra}` : "N/A"}</span>
                    </div>
                    <div className={`flex items-center justify-between pt-1.5 mt-1.5 border-t ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}>
                      <span className="text-xs font-semibold text-gray-500 dark:text-gray-400">Total</span>
                      <span className={`text-sm font-bold ${isSelected ? "text-indigo-600 dark:text-indigo-400" : "text-gray-800 dark:text-white"}`}>
                        {row.codTotalPrice ? `₹${row.codTotalPrice}` : "N/A"}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center py-16 text-center">
            <div className="w-14 h-14 rounded-2xl bg-gray-100 dark:bg-gray-800 flex items-center justify-center mb-3">
              <RiMoneyRupeeCircleFill className="text-gray-400" size={24} />
            </div>
            <p className="text-sm font-medium text-gray-500 dark:text-gray-400">No rates available</p>
          </div>
        )}
      </DialogContent>

      {/* Sticky footer action */}
      <div className={`flex-shrink-0 flex items-center justify-between gap-4 px-4 md:px-6 py-4 border-t backdrop-blur-md ${isDarkMode ? "bg-darkmodeColor/90 border-gray-800" : "bg-white/90 border-gray-200"}`}>
        <div className="text-xs text-gray-400 hidden sm:block">
          {selectedRowData?.id ? (
            <span>Selected: <span className="font-semibold text-gray-600 dark:text-gray-300 capitalize">{selectedRowData.courier} · {selectedRowData.mode}</span></span>
          ) : (
            "Select a courier option to continue"
          )}
        </div>
        <button
          className="w-full sm:w-auto text-sm font-bold bg-gradient-to-r from-indigo-600 to-purple-700 hover:shadow-lg hover:shadow-indigo-500/25 hover:-translate-y-0.5 disabled:from-gray-400 disabled:to-gray-500 disabled:cursor-not-allowed disabled:hover:translate-y-0 text-white rounded-xl h-11 px-6 flex items-center justify-center gap-2 transition-all duration-200"
          onClick={handleCreateShipment}
          disabled={!selectedRowId || isSubmitting}
        >
          {isSubmitting ? <Spinner /> : (type === "reverse" ? "Reverse Shipment" : "Create Shipment")}
        </button>
      </div>
    </Dialog>
  );
};

export default ViewRateForword;